var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a-button',{staticClass:"upload-type",attrs:{"type":"primary","loading":_setup.uploading},on:{"click":_setup.uploadFisher}},[_vm._v(" 本地上传 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }